import { createSelector } from 'reselect';
import CarditCriticalElementsCarrierPercentageColumns from '../../containers/CarditCriticalElementsCarrierPercentageColumns';
import CarditCriticalElementsCarrierNumberColumns from '../../containers/CarditCriticalElementsCarrierNumberColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_CRITICAL_ELEMENTS_CARRIER.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_CRITICAL_ELEMENTS_CARRIER.isLoading;

export const getData =
  ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.getDataFunction();

export const getPercentageColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.CARDIT_CRITICAL_ELEMENTS_CARRIER.requestParams, CarditCriticalElementsCarrierPercentageColumns);

export const getNumberColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.CARDIT_CRITICAL_ELEMENTS_CARRIER.requestParams, CarditCriticalElementsCarrierNumberColumns);
